import { render, staticRenderFns } from "./SportsData.vue?vue&type=template&id=47ca6e96&"
import script from "./SportsData.vue?vue&type=script&lang=js&"
export * from "./SportsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports